import React from 'react';
import { Container } from 'react-bootstrap'
import Timeline from './Timeline'

import { Content } from './styles';
import TimelineMobile from './TimelineMobile';

const BusinessInformation = () => {
  return (
      <Container>
          <Content>
            <section className="information" id="information">
                <p>Para quem é o <strong>FOTOP SERVIÇOS BUSINESS?</strong></p>
                <div>
                    <img src="/images/sala.jpg" alt="imagem" />
                    <div>
                        <p>
                            Ideal para empresas que possuem um volume recorrente de sessões de fotos como imobiliárias, plataformas de restaurante, imóveis, veículos e produtos.
                        </p>
                    </div>
                </div>
            </section>
            <section className="time-line">
                 <Timeline />
                 <TimelineMobile />
            </section>
            <section className="details">
                <p>O que <strong>oferecemos</strong></p>
                <div>
                    <img src="/images/plataforma.png" alt="imagem" />
                    <div>
                        <p> Sistema de <strong>agendamento online</strong></p>
                        <p><strong>Fotógrafos profissionais</strong> em todo o Brasil</p>
                        <p><strong>Gestão de agendamentos</strong>  com confirmação, realização e entrega do Job</p>
                        <p><strong>Entrega rápida </strong>do material após a sessão</p>
                        <p>Dashboard de <strong>acompanhamento online</strong></p>
                        <p><strong>Suporte especializado</strong></p>
                    </div>
                </div>
            </section>
          </Content>
      </Container>
  )
}

export default BusinessInformation;
